export const isValidHttpUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
};

export const normalizeClientWebsiteUrl = (value) => {
  if (typeof value !== 'string') return '';

  const normalized = value.trim();
  return normalized.toLowerCase() === 'null' ? '' : normalized;
};
